module.exports = __webpack_public_path__ + "vg.328b83d00e1371c7df7c.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/vendors/flag-icon/flags/1x1/vg.svg
// module id = ../../../../../src/assets/vendors/flag-icon/flags/1x1/vg.svg
// module chunks = 0